import Image from 'next/image';
import { Button, ButtonText, ContainerButtonPlay } from './styles';

const ButtonPlay = ({ handleOnClick, text }) => {
  return (
    <ContainerButtonPlay>
      <Button onClick={handleOnClick}>
        <Image loading="lazy" src="/assets/icons/play-campaign.svg" alt="" height={24} width={24} />
        <ButtonText>{text}</ButtonText>
      </Button>
    </ContainerButtonPlay>
  );
};

export default ButtonPlay;
